<template>
  <van-swipe class="my-swipe" :autoplay="3000">
    <van-swipe-item v-for="(item, index) in images" :key="index">
      <div class="my-swipe-image">
        <van-image :src="item.url"></van-image>
      </div>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
  export default {
    name: 'DetailBanner',
    props: {
      images: Array,
    },
  };
</script>

<style lang="scss" scoped>
/* 轮播图 */
.my-swipe-image {
  position: relative;
  width: 100%;
  padding-bottom: 52%;
}

.my-swipe-image .van-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
